import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * Utility-Funktion zum Zusammenführen von CSS-Klassen
 * Kombiniert clsx und tailwind-merge für optimale Klassenzusammenführung
 * 
 * clsx: Kombiniert Klassen bedingt (z.B. bei true/false Werten)
 * tailwind-merge: Löst Konflikte zwischen Tailwind-Klassen auf
 * 
 * @param {...any} inputs - CSS-Klassen als Strings, Arrays oder Objekte
 * @returns {string} Zusammengeführte CSS-Klassen ohne Konflikte
 * 
 * @example
 * ```jsx
 * // Einfache Kombination
 * cn("text-red-500", "bg-blue-500")
 * // → "text-red-500 bg-blue-500"
 * 
 * // Bedingte Klassen
 * cn("base-class", isActive && "active-class")
 * // → "base-class active-class" (wenn isActive true ist)
 * 
 * // Tailwind-Konflikt-Lösung
 * cn("p-2", "p-4")
 * // → "p-4" (letzter Wert gewinnt)
 * ```
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs))
} 